export class TestAnswer {

    public relations = [ 'question.test' ];

    public names = {
        test_question_id: function(data) {
            return data.question && data.question.test && (data.question.test.title + '->' + data.question.title);
        },
    };
}
